var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1135_116400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.60263 0.960938C0.722641 0.960938 0 1.5064 0 2.17064V30.5217C0 31.186 0.722641 31.7314 1.60263 31.7314C2.48262 31.7314 3.20526 31.186 3.20526 30.5217V2.17064C3.20526 1.5064 2.48262 0.960938 1.60263 0.960938Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4756 24.9492H13.1032V7.92285H27.4756L36.008 16.436L27.4756 24.9492Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8747 21.4233L13.1032 24.9491V7.92276L22.8747 4.39697V21.4233Z",
    fill: "#1D386E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8581 4.47754H0V21.1815H22.8581V4.47754Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52579 4.39697H0V21.4233H3.52579V4.39697Z",
    fill: "url(#paint0_linear_1135_116400)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M-0.000337601 4.47754H18.4368C18.9983 11.3768 6.10871 20.5234 0.0212193 17.2253L-0.000337601 4.47754Z",
    fill: "#95B1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50051 9.49487C5.42928 8.19466 5.97294 6.86688 5.32718 6.14867C4.698 5.4344 3.12089 5.6008 2.19224 6.90115C1.25253 8.19242 1.37785 10.0679 2.0125 10.7771C2.65267 11.5004 3.56096 10.7863 4.50051 9.49487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35737 7.10917C9.9762 6.65775 10.0167 6.01026 9.36876 5.5578C8.7234 5.10723 7.63429 5.02267 7.01549 5.47408C6.39459 5.92291 6.48383 6.72919 7.12971 7.17904C7.77736 7.63226 8.73644 7.55794 9.35737 7.10917Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1135_116400",
    x1: -10.1927,
    y1: 1.63404,
    x2: 3.69887,
    y2: 14.7307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1135_116400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.54,
    height: 30.7705,
    fill: "white",
    transform: "translate(0 0.960938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.c91d0fac688b3f804c5d.svg";
export { ForwardRef as ReactComponent };